import React, { useState, useEffect } from "react";
import "./BottomPanel.scss"; // Import the CSS file

export interface IBottomPanelProps {
  customComponent?: any;
  setShowSection?:any;
}
const BottomPanel = (props: IBottomPanelProps) => {
  const [isOpen, setIsOpen] = useState(true); // Automatically opens on load

  // Close panel when clicking outside (overlay)
  const handleOverlayClick = () => {
    setIsOpen(false);
    props?.setShowSection(false)
  };
  return (
    <div>
      {/* Overlay (Backdrop) */}
      <div
        className={`overlay ${isOpen ? "show" : ""}`}
        onClick={() => {
       //   setIsOpen(false);
          handleOverlayClick();
        }}
      ></div>

      {/* Bottom Panel Content */}
      <div className={`bottom-panel ${isOpen ? "open" : ""}`}>
        {/* Drag Handle */}
        <div
          className="drag-handle"
          onClick={() => {
         
            handleOverlayClick();
          }}
        ></div>

        {/* Close Button */}
        <button
          className="close-btn"
          onClick={() => {
            //setIsOpen(false);
            handleOverlayClick();
          }}
        >
          ✕
        </button>

        {/* Content */}
        {props?.customComponent()}
        {/* <h2>Bottom Panel</h2>
        <p>This panel opens automatically and works on all mobile screens.</p> */}
      </div>
    </div>
  );
};

export default BottomPanel;
